export const intersectionObserverMixin = {
    data() {
        return { observer: null }
    },
    methods: {
        observe(target, callback) {
            // browser doesn't support IO, just callback
            if (!window.IntersectionObserver) {
                callback()
                return
            }

            // If the observer has already been created then we need to clean up first
            if (this.observer) {
                this.observer.disconnect()
            }
            // for now all items will start to load 150px before they come into view
            const options = {
                rootMargin: '150px',
            }

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback()
                        this.observer.disconnect()
                    }
                })
            }, options)

            this.observer.observe(target)
        },
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect()
        }
    },
}
